<template>
  <BasePopup ref="popup" title="Change email">
    <div class="sign-up">
      <form class="shortform-sign-up__form" @submit.prevent="submitForm">
        <fieldset id="support-edit-form-group-subject" class="form__group">
          <div tabindex="-1" role="group">
            <label class="form__label form__label--large">
              Email address
            </label>
            <InputWithContextMenu
              id="email-field"
              ref="emailInput"
              v-model.trim="view.model.email"
              type="text"
              autofocus
              :class="view.validation.stateClass('email')"
              class="form-control"
            />
            <FormError :errors="view.validation.errors" field="email" />
          </div>
        </fieldset>
        <div class="shortform-sign-up__group">
          <AppButton
            id="email-change-submit"
            class="app-btn btns--yellow"
            type="submit"
          >
            Save Changes
          </AppButton>
        </div>
      </form>
    </div>
  </BasePopup>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import BasePopup from '@/components/ui/BasePopup.vue'
import AppButton from '@/app/components/button/AppButton.vue'
import InputWithContextMenu from '@/app/components/InputWithContextMenu.vue'
import FormError from '@/components/ui/FormError.vue'
import { auth } from '@/services/auth'

const popup = ref<InstanceType<typeof BasePopup> | null>(null)
const emailInput = ref<InstanceType<typeof InputWithContextMenu> | null>(null)

import { ChangeEmailPopupView } from '@/models/settings'
const view = ref(new ChangeEmailPopupView())

async function show(): Promise<void> {
  view.value.validation.reset()
  view.value.initWithEmail(auth.getEmail() ?? '')
  popup.value?.show()
}

function hide(): void {
  popup.value?.hide()
}

async function submitForm(): Promise<void> {
  await view.value.submitForm()
  if (isSuccess()) {
    hide()
  }
}

function isSuccess(): boolean {
  return view.value.state === 'success'
}

defineExpose({
  show,
  hide,
  isSuccess,
})
</script>
